// JsFromRoutes CacheKey fd1ba1bb6783a935e0459715cfbf89b9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '/users/integrations'),
}
